import * as R from "ramda";

class Address {
  // eslint-disable-next-line no-useless-constructor, no-empty-function
  constructor(public latitude: number, public longitude: number, public text: string) {}

  isComplete(): boolean {
    return !R.any(R.isEmpty, [this.latitude, this.longitude, this.text]);
  }
}
export type AddressType = InstanceType<typeof Address>;
export default Address;
